import { getHostApi } from './getHostApi';

export const baseUrl = (locale = 'us') => {
    return getHostApi(locale).NEXT_PUBLIC_API_HOST;
};

export const loginUrl = (locale = 'us') => {
    return getHostApi(locale).NEXT_PUBLIC_LOGIN_HOST;
};
